<template lang="">
    <div class="bbs_write">
      <table class="bbs_tbl">
        <colgroup>
          <col style="width:140px">
          <col style="width:auto">
        </colgroup>
        <tbody>
          <!--
          <tr>
            <th scope="row">카테고리</th>
            <td>
              <div class="item">
                <div class="lft_area" style="width:274px">
                  <select name="" id="" class="i_sel" style="width:260px" v-model="categorySeq">
                    <option
                      v-for="category in categoryListForCreate"
                      :value="category.categorySeq"
                    >{{ category.name }}</option>
                  </select>
                </div>
              </div>
            </td>
          </tr>
          -->
          <tr>
            <th scope="row">카테고리</th>
            <td>
              <div class="item">
                <div class="lft_area" style="width:274px">
                  <select v-model="selected1DepthCampaignCategorySeq" class="i_sel" style="width:260px">
                    <option :value="null">상위 카테고리 선택</option>
                    <option v-for="category in campaignCategoryListForCreate" :key="category.seq" :value="category.seq">
                      {{ category.name }}
                    </option>
                  </select>
                </div>
                <div class="lft_area" style="width:274px">
                  <select v-model="categoryCampaignSeq" class="i_sel" style="width:260px" :disabled="!selected1DepthCampaignCategorySeq">
                    <option :value="null">하위 카테고리 선택</option>
                    <option v-for="child in campaignCategories2Depth" :key="child.seq" :value="child.seq">
                      {{ child.name }}
                    </option>
                  </select>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">기부처</th>
            <td>
              <div class="item">
                <div class="lft_area" style="width:274px">
                  <select v-model="selected1DepthDonationCategorySeq" class="i_sel" style="width:260px">
                    <option :value="null">상위 기부처 선택</option>
                    <option v-for="donation in donationCategoryListForCreate" :key="donation.seq" :value="donation.seq">
                      {{ donation.name }}
                    </option>
                  </select>
                </div>
                <div class="lft_area" style="width:274px">
                  <select v-model="categoryDonationSeq" class="i_sel" style="width:260px" :disabled="!selected1DepthDonationCategorySeq">
                    <option :value="null">하위 기부처 선택</option>
                    <option v-for="child in donationCategories2Depth" :key="child.seq" :value="child.seq">
                      {{ child.name }}
                    </option>
                  </select>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">제휴기관</th>
            <td>
              <div class="item">
                <div class="lft_area" style="width:274px">
                  <select class="i_sel" style="width:260px" v-model="partnerSeq">
                    <option :value="null">제휴기관 선택</option>
                    <option
                      v-for="partner in partnerListForCreate"
                      :value="partner.partnerSeq"
                    >{{ partner.name }}</option>
                  </select>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">노출순서</th>
            <td>
              <div class="item">
                <input type="text" class="i_txt type_full lineless" placeholder="노출순서를 입력하세요." v-model="sortOrder">
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">캠페인명</th>
            <td>
              <div class="item">
                <input type="text" class="i_txt type_full lineless" placeholder="캠페인명을 입력하세요." v-model="campaignName">
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">금액</th>
            <td>
              <div class="item">
                <input type="text" class="i_txt type_full lineless" placeholder="금액을을 입력하세요." v-model="campaignAmount" @input="filterInput">
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">제휴사</th>
            <td>
              <div class="item">
                <input type="text" class="i_txt type_full lineless" placeholder="제휴사를 입력하세요." v-model="partnerCompany">
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">제휴담당자</th>
            <td>
              <div class="item">
                <input type="text" class="i_txt type_full lineless" placeholder="제휴 담당자를 입력하세요." v-model="partnerManager">
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">후원타입</th>
            <td>
              <div class="item">
                <input type="text" class="i_txt type_full lineless" placeholder="후원타입을 입력하세요." v-model="type">
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">종료일자</th>
            <td>
              <div class="ui_period">
                <span class="bbs_datepicker"><input type="date" id="datepicker_end" v-model="endDate"></span>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">설명</th>
            <td>
              <div class="item">
                <textarea name="" id="" cols="30" rows="9" class="i_ta type_full lineless" placeholder="설명을 입력하세요." v-model="description"></textarea>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">내용</th>
            <td>
              <div class="item">
                <textarea name="" id="" cols="30" rows="9" class="i_ta type_full lineless" placeholder="상세내용을 입력하세요." v-model="content"></textarea>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">썸네일이미지</th>
            <td>
              <div class="item item_attach">
                <p class="note">(확장자는 jpg, pdf, doc, ppt, hwp, zip 만 가능합니다.)</p>
                <div class="ui_attach" v-for="(row, index) in thumbnails" :key="index">
                  <input type="text" class="i_txt i_file" :value="row.fileName" @click="triggerFileInput(index)" readonly>
                  <button type="button" class="bt_base primary btn_attach" @click="triggerFileInput(index)"> 찾아보기</button>
                  <button type="button" class="bt_base gray type_ico" @click="removeRow(index)" style="margin-right:5px"> &minus; </button>
                  <button type="button" class="bt_base gray type_ico" @click="addRow" v-if="index == 0" > &plus; </button>
                  <input type="file" name="file" class="i_upload" style="display: none" @change="handleFileChange(index)" accept="image/*" ref="file">
                  <div v-if="row.previewUrl" class="preview">
                    <img :src="$getImgUrl(row.previewUrl)" alt="이미지 미리보기" style="max-width: 200px; max-height: 200px; margin-top: 10px;">
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="bbs_controller">
      <div class="lft_area">
        <a class="bt_base gray large_h btn_list" @click="toList">목록</a>
      </div>

      <div class="rgt_area">
        <button type="button" class="bt_base primary large_h" @click="saveCampaign">저장</button>
        <button type="reset" class="bt_base gray large_h" v-if="campaignSeq" @click="deleteCampaign">삭제</button>
      </div>
    </div>
  </template>

  <script>
  import { mapActions, mapState } from 'vuex';

  const adminCampaignModule = 'adminCampaignModule'
  const adminCategoryModule = 'adminCategoryModule'
  const adminCampaignCategoryModule = 'adminCampaignCategoryModule'
  const adminDonationCategoryModule = 'adminDonationCategoryModule'
  const adminPartnerModule = 'adminPartnerModule'

  export default {
    data (){
      return {
        campaignSeq: this.$route.query.campaignSeq,
        categorySeq: '',
        campaignName: '',
        campaignAmount: 0,
        partnerCompany: '',
        partnerManager: '',
        type: '',
        endDate: '',
        description: '',
        content: '',
        deletedFileSeqs: [],
        thumbnails: [{}],

        categoryCampaignSeq: null,
        categoryDonationSeq: null,
        partnerSeq: null,
        sortOrder: 1,

        selected1DepthCampaignCategorySeq: null,
        selected1DepthDonationCategorySeq: null
      }
    },
    methods: {
      ...mapActions(adminCampaignModule, [
        'requestSaveCampaign',
        'requestCampaign',
        'requestDeleteCampaigns',
      ]),

      ...mapActions(adminCategoryModule, [
        'requestCategoryListForCreate'
      ]),

      ...mapActions(adminCampaignCategoryModule, [
        'requestCampaignCategoryListForCreate'
      ]),

      ...mapActions(adminDonationCategoryModule, [
        'requestDonationCategoryListForCreate'
      ]),

      ...mapActions(adminPartnerModule, [
        'requestPartnersForCreate'
      ]),

      filterInput () {
        this.campaignAmount = this.$filterAmountInput(this.campaignAmount);
      },

      async onTypeChange () {
        await this.requestCategoryListForCreate('캠페인');
        this.categorySeq = this.categoryListForCreate[0].categorySeq
      },

      triggerFileInput(index) {
        const fileInputs = this.$refs.file;
        if (fileInputs && fileInputs[index]) {
          fileInputs[index].click();
        }
      },

      addRow() {
        this.thumbnails.push({});
      },

      removeRow(index) {
        if (this.thumbnails[index].fileSeq) {
          this.deletedFileSeqs.push(this.thumbnails[index].fileSeq);
        }

        if (this.thumbnails.length != 1) {
          this.thumbnails.splice(index, 1);
        } else {
          this.thumbnails = [{}];
        }
      },

      toList () {
        this.$router.push({ name: "CampaignManageListPage" })
      },

      async saveCampaign() {
        if (!this.categoryCampaignSeq) {
          alert("캠페인 카테고리를 선택해주세요.");
          return;
        }

        if (!this.categoryDonationSeq) {
          alert("기부처를 선택해주세요.");
          return;
        }

        if (!this.partnerSeq) {
          alert("제휴기관을 선택해주세요.");
          return;
        }

        const convertedContent = this.content.replace(/\n/g, '<br>');
        const { campaignSeq, categorySeq, campaignName, campaignAmount, partnerCompany, partnerManager, type, description, endDate, deletedFileSeqs, thumbnails, categoryCampaignSeq, categoryDonationSeq, partnerSeq, sortOrder } = this

        const formData = new FormData();
        formData.append('campaignSeq', campaignSeq ? campaignSeq : -1);
        formData.append('categorySeq', categorySeq);
        formData.append('campaignName', campaignName);
        formData.append('campaignAmount', campaignAmount == 0 ? 0 : parseInt(campaignAmount.replace(/,/g, ''), 10));
        formData.append('partnerCompany', partnerCompany);
        formData.append('partnerManager', partnerManager);
        formData.append('type', type);
        formData.append('endDate', endDate);
        formData.append('description', description);
        formData.append('content', convertedContent);
        formData.append('deletedFileSeqs', deletedFileSeqs);

        formData.append('categoryCampaignSeq', categoryCampaignSeq);
        formData.append('categoryDonationSeq', categoryDonationSeq);
        formData.append('partnerSeq', partnerSeq);
        formData.append('sortOrder', (sortOrder && Number(sortOrder) > 0) ? Number(sortOrder) - 1 : 0);

        thumbnails.forEach((file) => {
          formData.append('thumbnails', file.file);
        });

        const result = await this.requestSaveCampaign(formData);

        if (result) {
          alert(result)
          this.$router.push({ name: "CampaignManageListPage" })
        }
      },

      async deleteCampaign () {
        await this.requestDeleteCampaigns([this.campaignSeq]);
        alert("삭제되었습니다.")
        this.$router.push({ name: "CampaignManageListPage" })
      },

      handleFileChange (i) {
        const fileInput = this.$refs.file;
        const file = fileInput[i].files[0];
        if (file) {
          if (!file.type.startsWith("image/")) {
            alert("이미지 파일만 업로드할 수 있습니다.");
            fileInput[i].value = "";
            this.thumbnails[i].file = null;
            this.thumbnails[i].fileName = "";
            this.thumbnails[i].previewUrl = null;
            return;
          }

          this.thumbnails[i].file = file;
          this.thumbnails[i].fileName = file.name;
          if(this.thumbnails[i].fileSeq) this.deletedFileSeqs.push(this.thumbnails[i].fileSeq);

          const reader = new FileReader();
          reader.onload = (e) => {
            this.thumbnails[i].previewUrl = e.target.result;
          };
          reader.readAsDataURL(file);
        }
      },

      findCampaignCategoryParentSeq(childSeq) {
        for (const parent of this.campaignCategoryListForCreate) {
          if (parent.children.some(child => child.seq === childSeq)) {
            return parent.seq;
          }
        }
        return null;
      },

      findDonationCategoryParentSeq(childSeq) {
        for (const parent of this.donationCategoryListForCreate) {
          if (parent.children.some(child => child.seq === childSeq)) {
            return parent.seq;
          }
        }
        return null;
      }
    },

    computed: {
      ...mapState(adminCategoryModule, ['categoryListForCreate']),
      ...mapState(adminCampaignModule, ['campaign']),
      ...mapState(adminCampaignCategoryModule, ['campaignCategoryListForCreate']),
      ...mapState(adminDonationCategoryModule, ['donationCategoryListForCreate']),
      ...mapState(adminPartnerModule, ['partnerListForCreate']),

      campaignCategories2Depth() {
        if (!this.selected1DepthCampaignCategorySeq) {
          return [];
        }
        const selectedParent = this.campaignCategoryListForCreate.find(
          category => category.seq === this.selected1DepthCampaignCategorySeq
        );

        return selectedParent ? selectedParent.children : [];
      },

      donationCategories2Depth() {
        if (!this.selected1DepthDonationCategorySeq) {
          return [];
        }
        const selectedParent = this.donationCategoryListForCreate.find(
          donation => donation.seq === this.selected1DepthDonationCategorySeq
        );

        return selectedParent ? selectedParent.children : [];
      }
    },

    watch: {
      selected1DepthCampaignCategorySeq() {
        this.categoryCampaignSeq = null;
      },

      selected1DepthDonationCategorySeq() {
        this.categoryDonationSeq = null;
      }
    },

    async mounted() {
      if (this.campaignSeq) {
        await this.requestCampaign(this.campaignSeq);
        await this.requestCategoryListForCreate('캠페인');
        await this.requestCampaignCategoryListForCreate();
        await this.requestDonationCategoryListForCreate();
        await this.requestPartnersForCreate();

        this.categorySeq = this.campaign.category.categorySeq;
        this.campaignName = this.campaign.campaignName;
        this.campaignAmount = this.$addComma(this.campaign.campaignAmount);
        this.partnerCompany = this.campaign.partnerCompany;
        this.partnerManager = this.campaign.partnerManager;
        this.type = this.campaign.type;
        this.endDate = this.campaign.endDate;
        this.description = this.campaign.description;
        this.content = this.campaign.content.replace(/<br\s*\/?>/g, `\n`);
        if (this.campaign.attachList.length != 0) {
          this.thumbnails = this.campaign.attachList.map((attach, index) => ({
            fileName: attach.originalName,
            previewUrl: attach.path,
            fileSeq: attach.campaignAttachSeq
          }));
        }

        this.partnerSeq = this.campaign.partnerSeq ?? (this.partnerListForCreate[0]?.partnerSeq ?? null);
        this.sortOrder = this.campaign.sortOrder + 1;

        if (this.campaign.categoryCampaignSeq) {
          const parentCampaignCategorySeq = this.findCampaignCategoryParentSeq(this.campaign.categoryCampaignSeq);

          if (parentCampaignCategorySeq) {
            this.selected1DepthCampaignCategorySeq = parentCampaignCategorySeq;
            this.$nextTick(() => {
              this.categoryCampaignSeq = this.campaign.categoryCampaignSeq;
            });
          }
        }

        if (this.campaign.categoryDonationSeq) {
          const parentDonationCategorySeq = this.findDonationCategoryParentSeq(this.campaign.categoryDonationSeq);

          if (parentDonationCategorySeq) {
            this.selected1DepthDonationCategorySeq = parentDonationCategorySeq;
            this.$nextTick(() => {
              this.categoryDonationSeq = this.campaign.categoryDonationSeq;
            });
          }
        }
      } else {
        await this.requestCategoryListForCreate('캠페인');
        this.categorySeq = this.categoryListForCreate[0].categorySeq;
        await this.requestCampaignCategoryListForCreate();
        this.categoryCampaignSeq = null;
        await this.requestDonationCategoryListForCreate();
        this.categoryDonationSeq = null;
        await this.requestPartnersForCreate();
        this.partnerSeq = null;;
      }
    }

  }
  </script>
  <style lang="">

  </style>